import styles from './style.module.scss';
import { Col, Row, Spin, Table, Typography } from 'antd';
import useInvoicesAtvVillage from '../useInvoicesAtvVillage';
import UIHelper from '../../../../../helpers/UIHelper';
import LineChart from '../../../charts/lineChart';
import PrintFilterText from '../../printFiiterText';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const {
    data,
    columns,
    summary,
    loading,
    format,
    title,
    searchParams,
    formatMoney,
    filters,
  } = useInvoicesAtvVillage(true, allReportsData, isAllReports);
  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const searchParamsObj = Object.fromEntries([...searchParams]);
  const searchParamsObjKeys = Object.keys(searchParamsObj);
  const availableFilters = filters.filter((i) =>
    searchParamsObjKeys.includes(i.name),
  );

  return (
    <>
      <div className={styles.container}>
        <Spin spinning={loading}>
          {!allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>{title}</Typography.Title>
              </Col>
              <PrintFilterText
                availableFilters={availableFilters}
                searchParams={searchParams}
              />
            </Row>
          )}
          {allReports && (
            <Row className={styles.titleSection} justify={'center'}>
              <Col>
                <Typography.Title level={3}>ATV vs LY</Typography.Title>
              </Col>
            </Row>
          )}
          <br />
          <Row>
            <Col xs={24} xl={10}>
              <Table
                columns={UIHelper.assignTire(columns)}
                dataSource={data.tableData}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 500 }}
                summary={summary}
                loading={loading}
              />
            </Col>
            <Col span={14} className={'chartColl'}>
              <LineChart
                data={data.lineChartData}
                tableData={data.tableData}
                colors={['#61cdbb', '#f47560']}
                format={formatMoney}
              />
              <br />
              <LineChart
                data={data.lineChartData2}
                tableData={data.tableData}
                colors={['#61cdbb', '#f47560']}
                format={format}
              />
            </Col>
          </Row>
        </Spin>
      </div>
    </>
  );
};

export default Print;
